import { openErrorNotification } from 'graphql/hooks/common';

export const downloadCsvFromBase64 = (base64: string) => {
  try {
    const byteCharacters = atob(base64); // Decode base64 to string
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'text/csv' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `users_${Date.now()}.csv`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    openErrorNotification('Failed to download CSV from base64');
  }
};
